module.exports = __webpack_public_path__ + "img/Group 5359.56eb6d42.png";